import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import auth from '../../../auth/';
import axios from "axios";
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


var getUrl = api.proyectos.config.presupuesto.tiposdecosto.treeselect;


class AgregarCosto extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: [],
            expanded: [],
            options: []
        };

        this.getOptions();
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
        onChange: PropTypes.func,
        checked: PropTypes.any,
        disabled: PropTypes.bool,
        buttonClass: PropTypes.string
    }

    static defaultProps = {
        disabled: false,
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.options.length > 0)
            this.setState({
                checked: nextProps.checked.map(x => x.pk.toString())
            });
    }

    resetState() {
        this.setState({
            checked: this.props.checked.map(x => x.pk.toString())
        });
    }

    getOptions = function () {
        axios.get(getUrl, auth.header())
            .then((response) => {
                this.setState({ options: response.data.rows });
                if (this.props.checked)
                    setTimeout(() => this.resetState(), 100);
            });
    };

    Submit() {
        var checked = this.state.checked;
        var opts = this.state.options;
        var values = [];
        for (var i = 0; i < checked.length; i++) {
            for (var j = 0; j < opts.length; j++) {
                if (opts[j].value == checked[i])
                    values.push({
                        pk: opts[j].value,
                        nombre: opts[j].label
                    });
            }
        }
        this.props.onSubmit(values);
    }

    render() {
        return (
            <ParadigmaModal
                onSubmit={(callback) => this.Submit(callback)}
                id={this.props.id}
                title={"Seleccione un Tipo de Costo"}
                buttonIcon={"fa fa-plus fa-lg"}
                buttonClass={this.props.buttonClass}
                saveButton={true}
                closeButton={true}
            >
                <Row>
                    <Col className="col-12">
                        {this.state.options &&
                            <CheckboxTree
                                nodes={this.state.options}
                                checked={this.state.checked}
                                expanded={this.state.expanded}
                                onCheck={checked => this.setState({ checked })}
                                onExpand={expanded => this.setState({ expanded })}
                            />
                        }
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default AgregarCosto;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento3/AgregarCosto.js